// I think this is just a bad idea. I think switching to flickity is better but time is an issue

document.addEventListener('DOMContentLoaded', function () {

    console.log('dog_treats.js')

    const settings = {
        watchCSS: true,
        wrapAround: true
    }

    var $carousel = $('.dog-treat-slick').flickity(settings)
    
    // let dog_treats_element = document.querySelector('.dog-treat-slick');

    // $('.dog-treat-slick').slick({
    //     slidesToShow: 3,
    //     draggable: false,
    //     arrows: false,
    //     infinite: true,
    //     responsive: [
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 infinite: true,
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 centerMode: true,
    //                 infinite: true,
    //                 dots: true,
    //             }
    //         },
    //     ]
    // });

});
